<script setup>
import { ref, computed, watch } from "vue";
import Button from 'primevue/button';
import Textarea from 'primevue/textarea';
import InlineMessage from "primevue/inlinemessage";
import OpcoesTipoPergunta from "@/components/professor/CriarQuestoes/OpcoesTipoPergunta.vue";
import OpcoesConceitos from "@/components/professor/CriarQuestoes/OpcoesConceitos.vue";
import OpcoesDisciplinas from "@/components/professor/CriarQuestoes/OpcoesDisciplinas.vue";
import { useModeloQuestao } from "@/composables/useModeloQuestao";
const modeloQuestao = useModeloQuestao();
import { atualizarQuestao, salvarQuestao } from "@/api/fetchQuestoes";

const loadingButton = ref(false);
const questao = defineModel('questao');
const arrayDeConceitos = computed(() => {
    return questao.value.conceitos !== null && questao.value.conceitos !== '' ? questao.value.conceitos.split(',') : []
});
const arrayConceitosModificavel = ref(arrayDeConceitos.value);

watch(arrayConceitosModificavel, (newVal) => {
    questao.value.conceitos = arrayConceitosModificavel.value.join(', ')
}, { deep: true });

function definirAlternativaCorreta(letra) {
    questao.value.gabarito = letra
}

const erros = ref([]);

function validarQuestao() {
    erros.value = [];
    if (questao.value.tipo === 1) {
        if (questao.value.pergunta.trim() === '') {
           erros.value.push("Adicione uma pergunta");
        }
        if (questao.value.gabarito.trim() === '') {
            erros.value.push("Selecione uma alternativa correta");
        }
        if (questao.value.a.trim() === '') {
           erros.value.push("Preencha a alternativa A");
        }
        if (questao.value.b.trim() === '') {
            erros.value.push("Preencha a alternativa B");
        }
    }

    if (questao.value.tipo === 2) {
        if (questao.value.pergunta.trim() === '') {
            erros.push("Adicione uma pergunta");
        }
    }

    if (questao.value.tipo === 2) {
        questao.value.gabarito = '';
        questao.value.a = '';
        questao.value.b = '';
        questao.value.c = '';
        questao.value.d = '';
        questao.value.e = '';
    }
    
    return erros.value.length === 0;
}

async function atualizar(){
    if (!validarQuestao()) {
        return;
    }
    if (questao.value.id === null) {
        salvar();
        return;
    }
    loadingButton.value = true;
    let data = await atualizarQuestao(questao.value.id, questao.value);
    loadingButton.value = false;
    emit('update:visible', false);
}

async function salvar() {
    loadingButton.value = true;
    let questaoParaSalvar = {...questao.value};
    delete questaoParaSalvar.id;
    let result = await salvarQuestao(questaoParaSalvar);
    if(result){
       questao.value = modeloQuestao;
       questaoParaSalvar = null;
    }
    loadingButton.value = false;
}

// watch(questao, () => {
//     if(erros.value.length === 0) return;
//     validarQuestao();
// }, { deep: true });

const emit = defineEmits(['update:visible'])


</script>
<template>
    <div class="flex flex-column gap-4">
        <div class="grid">
            <OpcoesTipoPergunta v-model="questao.tipo" class="col-12 lg:col-6" />
            <OpcoesDisciplinas v-model="questao.disciplina" class="col-12 lg:col-6" />
        </div>
        <OpcoesConceitos v-model="arrayConceitosModificavel" />
        <div class="flex flex-column gap-2 mt-2">
            <label>Imagem</label>
            <Textarea v-model="questao.imagem" rows="1" class="w-full" />
        </div>

        <div class="flex flex-column gap-2">
            <label>Texto de apoio</label>
            <Textarea v-model="questao.texto" rows="3" class="w-full" autoResize />
        </div>

        <div class="flex flex-column gap-2">
            <label>Pergunta</label>
            <Textarea v-model="questao.pergunta" rows="1" class="w-full" autoResize />
            <div class="text-red-500 text-sm" v-if="erroPergunta">Adicione uma pergunta</div>
        </div>

        <div class="flex flex-column gap-3" v-if="questao.tipo === 1">
            <div class="flex flex-row gap-3 align-items-center flex-grow-1">
                <div class="font-semibold border-round-md p-2 surface-200 cursor-pointer text-gray-700"
                    :class="{ 'bg-primary-500 text-white': questao.gabarito === 'a' }"
                    @click="definirAlternativaCorreta('a')">A
                </div>
                <div class="w-full">
                    <Textarea v-model="questao.a" rows="1" class="w-full" autoResize />
                    <div class="text-red-500 text-sm mt-1" v-if="erroA">Adicione a alternativa A</div>
                </div>
            </div>
            <div class="flex flex-row gap-3 align-items-center flex-grow-1">
                <div class="font-semibold border-round-md p-2 surface-200 cursor-pointer text-gray-700"
                    :class="{ 'bg-primary-500 text-white': questao.gabarito === 'b' }"
                    @click="definirAlternativaCorreta('b')">B
                </div>
                <div class="w-full">
                    <Textarea v-model="questao.b" rows="1" class="w-full" autoResize />
                    <div class="text-red-500 text-sm mt-1" v-if="erroB">Adicione a alternativa B</div>
                </div>
            </div>
            <div class="flex flex-row gap-3 align-items-center flex-grow-1">
                <div class="font-semibold border-round-md p-2 surface-200 cursor-pointer text-gray-700"
                    :class="{ 'bg-primary-500 text-white': questao.gabarito === 'c' }"
                    @click="definirAlternativaCorreta('c')">C
                </div>
                <Textarea v-model="questao.c" rows="1" class="w-full" autoResize />
            </div>
            <div class="flex flex-row gap-3 align-items-center flex-grow-1">
                <div class="font-semibold border-round-md p-2 surface-200 cursor-pointer text-gray-700"
                    :class="{ 'bg-primary-500 text-white': questao.gabarito === 'd' }"
                    @click="definirAlternativaCorreta('d')">D
                </div>
                <Textarea v-model="questao.d" rows="1" class="w-full" autoResize />
            </div>


        </div>
        <div v-for="erro in erros" class="flex flex-column gap-2">
            <InlineMessage severity="error">{{ erro }}</InlineMessage>
        </div>

        <Button :loading="loadingButton" label="Salvar" @click="atualizar" icon="pi pi-save" class="w-full" />
    </div>
</template>